import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=fd3a8d82"
import script from "./PaymentSuccess.vue?vue&type=script&lang=ts"
export * from "./PaymentSuccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports